// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768px","container":"FloatingCTA_container__s_E_Y"};